import { render, staticRenderFns } from "./adminAward.vue?vue&type=template&id=8b007cda&scoped=true&"
import script from "./adminAward.vue?vue&type=script&lang=js&"
export * from "./adminAward.vue?vue&type=script&lang=js&"
import style0 from "./adminAward.vue?vue&type=style&index=0&id=8b007cda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b007cda",
  null
  
)

export default component.exports